import { ArquivosAplicativoActionsTypes } from "./arquivosAplicativoActions"
import type { ArquivosAplicativoActionModel } from "./arquivosAplicativoActions"
import type { ArquivosAplicativoModel } from "../models/arquivosAplicativoModel"

export function arquivosAplicativoReducer(
    state: ArquivosAplicativoModel,
    action: ArquivosAplicativoActionModel
): ArquivosAplicativoModel {
    switch (action.type) {
        case ArquivosAplicativoActionsTypes.CARREGAR:
            return { ...action.payload }
        case ArquivosAplicativoActionsTypes.ATUALIZAR_URL:
            return { ...state, [action.payload.campo]: action.payload.url }
        default:
            return state
    }
}
